import { render, staticRenderFns } from "./homeDashboardTrainerStatistics.vue?vue&type=template&id=c25ca952&scoped=true"
import script from "./homeDashboardTrainerStatistics.vue?vue&type=script&lang=js"
export * from "./homeDashboardTrainerStatistics.vue?vue&type=script&lang=js"
import style0 from "./homeDashboardTrainerStatistics.vue?vue&type=style&index=0&id=c25ca952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25ca952",
  null
  
)

export default component.exports